import { Link } from "react-router-dom";
import Header from "../Components/Header";
import PracticePapersSidebar from "../Components/PracticePapersSidebar";
import { subtractionWorksheets } from "../Data/data";
import { Helmet } from 'react-helmet';
import useGoogleAnalytics  from "../utils/use-google-analytics"

const SubtractionWorksheets = () => {
  useGoogleAnalytics();
  return (
    <>
              <Helmet>
        <title>Practice Papers Subtraction</title>
        <meta name="description" content="A series of papers to practice subtraction"/>
        <meta property="og:type" content="article"/>
        <meta property="og:title" content="Mathpapers Practice Subtraction"/>
        <meta property="og:description" content="A series of papers to practice subtractions"/>
        <meta property="og:url" content={window.location.href}/>
        <meta property="article:modified_time" content={new Date().toJSON()}/>
        <meta property="og:image" content={`${window.location.origin}/assets/hero.jpg`}/>
        <meta property="og:image:width" content="100"/>
        <meta property="twitter:image" content={`${window.location.origin}/assets/hero.jpg`}/>
        <meta property="twitter:image:src" content={`${window.location.origin}/assets/hero.jpg`}/>
        <meta property="og:image:height" content="100"/>
        <meta name="twitter:image:height" content="100" data-react-helmet="true"/>
        <meta name="twitter:image:width" content="100" data-react-helmet="true"/>
        <meta property="og:image:type" content={"image/jpg"}/>
        <meta property="twitter:url" content={window.location.href}/>
        <meta property="twitter:title" content="Mathpapers Practice Subtraction"/>
        <meta property="twitter:description" content="A series of papers to practice subtraction"/>
        <meta property="og:type" content="article"/>
        <meta name="msapplication-TileImage" content={`${window.location.origin}/assets/hero.jpg`}/>
      </Helmet>
      <Header />
      <div className="py-32 flex justify-center">
        <div>
          <PracticePapersSidebar />
        </div>
        <div className="flex w-full">
          <div className="flex flex-col">
            <div className="lg:px-0 md:px-10 lg:text-start text-center sm:px-8 px-4 lg:mt-0 mt-10">
              <h1 className="mt-1 mb-2 pl-1 text-4xl font-semibold">
                Subtraction Math Facts Worksheets
              </h1>
              <p>
                These subtraction worksheets are similar to the
                <a
                  className="mx-1 text-blue400"
                  href="https://www.dadsworksheets.comhttps://www.dadsworksheets.com/2008/09/05/an-overview-of-rocket-math.html"
                >
                  <i className="font-semibold text-blue-500">RocketMath</i>
                </a>
                , <i>Wolf Swamp</i> or <i>Mastering Math Facts</i> subtraction
                worksheets used at many schools. These are typically one minute,
                timed tests. Try my super entertaining
                <a
                  className="mx-1 font-semibold text-blue-500"
                  href="https://www.dadsworksheets.comhttps://www.dadsworksheets.com/timer.html"
                >
                  online timer
                </a>{" "}
                if you or your kids are into silly sounds!
              </p>
            </div>
            <div className="w-full py-10 lg:px-0 md:px-10 px-5">
              {subtractionWorksheets.map((sheet, i) => (
                <div className="mt-10">
                  <h2 className="sm:text-xl font-semibold mb-2">
                    {sheet.title}
                  </h2>
                  <div className="w-full grid md:gap-10 gap-5 lg:pr-10 sm:grid-cols-4 grid-cols-2">
                    {sheet.sheets?.map((item) => (
                      <Link to={item.url} key={item.url} className="w-full">
                        <img
                          src={item.img}
                          alt=""
                          className="w-full transition-all duration-300 hover:scale-105"
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubtractionWorksheets;
